import BaseForm from '@kakadu-dev/base-frontend-helpers/forms/BaseForm';
import { PropertyType } from "../../models/Properties";
import { DispatchSelector, StateSelector } from "../../modules/selectors";
/**
 * Property type form
 */

export class PropertyTypeForm extends BaseForm {
  constructor(...args) {
    super(...args);
    this.fields = [{
      label: 'Название',
      name: 'name',
      required: true
    }, {
      label: 'Алиас',
      name: 'alias',
      required: true
    }, {
      label: 'Группа характеристики',
      name: 'groupId',
      required: true,
      type: BaseForm.TYPES.AUTOCOMPLETE,
      props: {
        common: {
          dataState: StateSelector.properties.propertiesGroups.list,
          dataFetch: DispatchSelector.properties.propertiesGroups.list,
          searchFilter: value => ({
            title: {
              like: `%${value}%`
            }
          }),
          valueColumn: 'id',
          labelColumn: 'title'
        }
      }
    }, {
      label: 'Тип фильтра',
      name: 'filterType',
      required: true,
      type: BaseForm.TYPES.DROPDOWN,
      props: {
        common: {
          data: BaseForm.getDropdownOptions(PropertyType.propertyFilters)
        }
      }
    }, {
      label: 'Подсказка',
      name: 'attributeHint'
    }, {
      label: 'Размерность',
      name: 'measure'
    }, {
      label: 'Позиция',
      name: 'sort'
    }, {
      label: 'Фильтр',
      name: 'isFilter',
      type: BaseForm.TYPES.TOGGLE
    }, {
      label: 'Свойство',
      name: 'isOption',
      type: BaseForm.TYPES.TOGGLE
    }, {
      label: 'Дополнительный фильтр',
      name: 'isAdditional',
      type: BaseForm.TYPES.TOGGLE
    }, {
      label: 'Динамический фильтр',
      name: 'isDynamic',
      type: BaseForm.TYPES.TOGGLE
    }, {
      label: 'Описание',
      name: 'description',
      type: BaseForm.TYPES.EDITOR
    }];
    this.dispatchCreateForm = DispatchSelector.properties.propertiesTypes.create;
    this.dispatchUpdateForm = DispatchSelector.properties.propertiesTypes.update;
    this.responseCreateState = StateSelector.properties.propertiesTypes.create;
    this.responseUpdateState = StateSelector.properties.propertiesTypes.update;
  }

}